module.exports = __webpack_public_path__ + "static/assets/89606977495eb20404fcfad6f6a58df3.gif";